/* eslint-disable react/prop-types */
import React from "react";
import get from "lodash/get";
import { connect } from "react-redux";
import { Button } from "../../atoms/button";
// import { SUBSCRIPTION_PAGE_URL } from "../../../constants";

import "./subscription-status-btn.m.css";
import { Loader } from "../../podcast-player/Loader";
import { useUserSubscriptionData } from "../../../context/useUserSubscription";

const SubscriptionStatusBtnWrapper = ({ member = {}, config }) => {
  const { hasActiveSubscription, isLoading } = useUserSubscriptionData();

  // const getOnetimePlan =
  //   userSubscription.filter(item => item.plan_occurrence === "One Time") || [];
  // const getRecuringPlan =
  //   userSubscription.filter(item => item.plan_occurrence === "Recurring") || [];
  // const checkActiveOTS =
  //   (userHasSubscription &&
  //     userSubscription.filter(
  //       item => item.plan_occurrence === "One Time" && item.active === true
  //     )) ||
  //   [];
  // const checkActiveRS =
  //   (userHasSubscription &&
  //     userSubscription.filter(
  //       item => item.plan_occurrence === "Recurring" && item.active === true
  //     )) ||
  //   [];
  // const checkExpiredOTS =
  //   getOnetimePlan.filter(item => item.status === "expired") || [];
  // const checkExpiredRS =
  //   checkActiveRS.filter(item => item.status === "expired") || [];
  // const domainSlug = get(config, ["domainSlug"], null);
  // const subDomainUrl = get(config, ["publisher", "subdomain_url"], "");
  // const host = domainSlug
  //   ? subDomainUrl
  //   : get(config, ["publisher", "frontend_url"], "");
  const getButtonText = () => {
    if (member) {
      if (isLoading) {
        return <Loader />;
      }

      if (hasActiveSubscription) {
        return "Gift";
      }

      return "Subscribe";
    }

    return "Subscribe";
  };

  return (
    <Button
      href={`/${hasActiveSubscription ? "gift" : "subscription"}?ref=nav`}
    >
      {" "}
      {getButtonText()}{" "}
    </Button>
  );
};

const mapStateToProps = state => {
  return {
    member: get(state, ["member"], null),
    userSubscription: get(state, ["isSubscribedUser", "userSubscription"], []),
    userHasSubscription: get(
      state,
      ["isSubscribedUser", "userHasSubscription"],
      null
    ),
    config: get(state, ["qt", "config"], {})
  };
};

export const SubscriptionStatusBtn = connect(
  mapStateToProps,
  null
)(SubscriptionStatusBtnWrapper);
